import { render, staticRenderFns } from "./details.vue?vue&type=template&id=601ba8c3&scoped=true&"
import script from "./details.vue?vue&type=script&lang=js&"
export * from "./details.vue?vue&type=script&lang=js&"
import style0 from "./details.vue?vue&type=style&index=0&id=601ba8c3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "601ba8c3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dgq/mei_bao_pro/insuranceagent-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('601ba8c3')) {
      api.createRecord('601ba8c3', component.options)
    } else {
      api.reload('601ba8c3', component.options)
    }
    module.hot.accept("./details.vue?vue&type=template&id=601ba8c3&scoped=true&", function () {
      api.rerender('601ba8c3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/insurance/product/details.vue"
export default component.exports